import React, { useState } from 'react';
import { Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMusic
} from "@fortawesome/free-solid-svg-icons";
import EnhancedSongManagement from '../../pages/songs/SongManagement';
import { useLanguage } from '../../contexts/LanguageContext';

function SongLibraryManager() {
  const { t } = useLanguage();
  const [activeView, setActiveView] = useState('songs'); // 'songs' or 'collections'

  // State for tracking counts
  const [songCounts, setSongCounts] = useState({
    user: 0,
    community: 0,
    all: 0
  });
  
  //const [collectionCounts, setCollectionCounts] = useState({
  //  user: 0,
  //  community: 0,
  //  all: 0
  //});

  // Load initial collection counts - only run once
  //useEffect(() => {
  //  let isMounted = true;
  //  
  //  async function loadInitialCollectionCounts() {
  //    try {
  //      const collections = await fetchCollections();
  //      
  //      // Only update state if component is still mounted
  //      if (isMounted) {
  //        const counts = {
  //          user: collections.filter(c => c.owner_type === 'user').length,
  //          community: collections.filter(c => c.owner_type === 'community').length,
  //          all: collections.length
  //        };
  //        setCollectionCounts(counts);
  //      }
  //    } catch (error) {
  //    }
  //  }
    
  //  loadInitialCollectionCounts();
    
//    // Cleanup function
//    return () => {
//      isMounted = false;
//    };
//  }, []); // Empty dependency array - only run once
  
  // Event handler for receiving counts from child components
  const handleSongCountsUpdate = (counts) => {
    setSongCounts(counts);
  };
  
//  const handleCollectionCountsUpdate = (counts) => {
//    setCollectionCounts(counts);
//  };

  return (
    <div className="dashboard-container">
      <div className="row">
        {/* Main content area */}
        <div className="col-12 col-lg-8 mb-4">
          {activeView === 'songs' && (
            <EnhancedSongManagement onCountsUpdate={handleSongCountsUpdate} />
//          ) : (
//            <SongCollectionManagement onCountsUpdate={handleCollectionCountsUpdate} />
          )}
        </div>
        
        {/* Sidebar */}
        <div className="col-lg-4">
          {/* Quick Navigation */}
          <div className="card shadow-sm border-0 rounded-4 mb-4">
            <div className="card-header bg-transparent">
              <h5 className="mb-0">{t('songbook.title')}</h5>
            </div>
            <div className="card-body p-0">
              <div className="list-group list-group-flush">
                <button
                  className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 ${activeView === 'songs' ? 'active' : ''}`}
                  onClick={() => setActiveView('songs')}
                >
                  <span><FontAwesomeIcon icon={faMusic} className="me-2" /> {t('songbook.songs')}</span>
                  <Badge bg={activeView === 'songs' ? 'light' : 'secondary'}
                         text={activeView === 'songs' ? 'primary' : 'white'}
                         pill>
                    {songCounts.all}
                  </Badge>
                </button>
                {/*<button 
                  className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 ${activeView === 'collections' ? 'active' : ''}`}
                  onClick={() => setActiveView('collections')}
                >
                  <span><FontAwesomeIcon icon={faFolderOpen} className="me-2" /> Zbirke</span>
                  <Badge bg={activeView === 'collections' ? 'light' : 'secondary'} 
                         text={activeView === 'collections' ? 'primary' : 'white'} 
                         pill>
                    {collectionCounts.all}
                  </Badge>
                </button>*/}
              </div>
            </div>
          </div>
          
          {/* Statistics */}
          <div className="card shadow-sm border-0 rounded-4">
            <div className="card-header bg-transparent">
              <h5 className="mb-0">{t('songbook.title')}</h5>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-between mb-3">
                <span>{t('songbook.totalSongs')}</span>
                <strong>{songCounts.all}</strong>
              </div>
              <div className="d-flex justify-content-between mb-3">
                <span>{t('songbook.mySongs')}</span>
                <strong>{songCounts.user}</strong>
              </div>
              {/* <div className="d-flex justify-content-between mb-3">
                <span>Stevilo zbirk:</span>
                <strong>{collectionCounts.all}</strong>
              </div>
              <div className="d-flex justify-content-between">
                <span>Moje zbirke:</span>
                <strong>{collectionCounts.user}</strong>
              </div>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SongLibraryManager;